import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Table from "components/Admin/Collectables/Collectables";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getRejected,
  approveCollectables,
  bounceCollectable,
} from "store/actions/collectables";

const Rejected = () => {
  const rejectedData = useSelector((state) => state.collectables.rejected);
  const dispatch = useDispatch();
  const [page, setPage] = useState(rejectedData ? rejectedData.pag.page : 1);
  const [amount, setAmount] = useState(
    rejectedData ? rejectedData.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    rejectedData ? rejectedData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    rejectedData ? rejectedData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");
  const [searchBy, setSearchBy] = useState(
    rejectedData ? rejectedData.pag.search_by : "item_name"
  );
  const history = useHistory();

  useEffect(() => {
    dispatch(
      getRejected(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, dispatch]);

  const showRecycableHandler = (id) => {
    history.push("/admin/recycables/show/" + id);
  };

  const approveRecycableHandler = (ids) => {
    dispatch(
      approveCollectables(
        ids,
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history,
        false
      )
    );
  };

  const bounceRecycableHandler = (id) => {
    dispatch(
      bounceCollectable(
        id,
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  };

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Rejected Collectables</h4>
        </CardHeader>
        <CardBody>
          {rejectedData && (
            <Table
              rows={rejectedData.data}
              totalRows={rejectedData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              showRecycable={showRecycableHandler}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              isSelectable={false}
              canApprove={false}
              approveRecycable={approveRecycableHandler}
              bounceRecycable={bounceRecycableHandler}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default Rejected;
